import { motion } from 'motion/react';
import { GeofleetChatMark } from './GeofleetChatMark';

const dot = {
  rest: { y: 0, opacity: 0.45 },
  bounce: { y: -4, opacity: 1 },
};

/**
 * Typing row aligned with assistant bubble styling.
 */
export function TypingIndicator() {
  return (
    <div className="flex flex-col items-start gap-1">
      <div
        className="inline-flex items-center gap-2 rounded-[18px] rounded-bl-md border border-neutral-200/60 bg-white/90 px-2.5 py-2 pr-3 shadow-sm sm:rounded-[20px] sm:px-3 sm:py-2.5"
        role="status"
        aria-label="Assistant is typing"
      >
        <GeofleetChatMark size={16} className="shrink-0" />
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="h-2 w-2 rounded-full bg-neutral-400"
            variants={dot}
            initial="rest"
            animate="bounce"
            transition={{
              duration: 0.45,
              repeat: Infinity,
              repeatType: 'reverse',
              delay: i * 0.12,
              ease: 'easeInOut',
            }}
          />
        ))}
      </div>
      <p className="pl-1 text-[11px] font-medium text-neutral-400">Geofleet · typing…</p>
    </div>
  );
}
